import { useEffect } from 'react'
import { Route, useHistory } from 'react-router-dom'
import config from '@/config'
import Footer from '@/components/footer'
import Landing from '@/pages/Pages/landing'
import Callback from '@/pages/Pages/callback'
import '@/utils/validation'

const { WEB_URL } = config
const registerLandlord = `${WEB_URL}/pricing`

const UnauthenticatedApp = ({ session }) => {
  const history = useHistory()

  useEffect(() => {
    if (session) {
      window.location = registerLandlord
    }
  }, [session, history])

  return (
    <>
      <Route path="/" component={Landing} />
      <Route
        path="/callback"
        render={props => {
          const { location } = props
          const queryParams = new URLSearchParams(location.search)
          const authToken = queryParams.get('auth_token')
          const url = queryParams.get('url')

          return <Callback authToken={authToken} url={url} />
        }}
      />
      <Footer />
    </>
  )
}

export default UnauthenticatedApp
